import { useEffect, useState, useContext, useRef } from 'react'
import useStore from '../../store/useStore'
import ReactDom from 'react-dom';
import html2canvas from "html2canvas";
import style from './index.module.scss'
//引入子组件
// import UseOnMouse from './useOnMouse';
import FileItemEdit from '../selectionFolder/fileItem/fileItemEdit/index'
import M2niCascadedList from '../selectionFolder/m2ni_cascaded_list/index'
import myContext from '../../utils/context'
import { Table, InputNumber, Image } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import {
    EyeOutlined, EyeInvisibleOutlined, TagOutlined
} from '@ant-design/icons';
import user_default from '../../static/image/user_default.png'

import { deepCopy, getImgUrlById } from '../../util';
import CanvasSelect from 'canvas-select';
import { stdin } from 'process';


interface Props {
    // history: any;
    onChange?: (...args: any[]) => void;
    annotation?: any,
    imgId?: any,
    disable?: any,
    type?: any
}
interface State {
    userInfo: any
}

interface DataType {
    key: React.Key;
    name: string;
}
const ImageOverlays = (props: Props) => {
    const [state, setState] = useState<State>({
        userInfo: {}
    });
    const { store, dispatch } = useStore();
    const [image, setImage] = useState<any>(null)

    const reviceProps = useContext(myContext)
    const [checkItemData, setCheckItemData] = useState<any>();
    // const [editItemData, setEditItemData] = useState<any>();

    const [isShowMark, setIsShowMark] = useState<boolean>(true);
    const [instance, setInstance] = useState<any>(null);
    const [instanceDataset, setInstanceDataset] = useState<any>(null);

    const [listActiveIndex, setListActiveIndex] = useState<any>(null);
    const imgOverAll = useRef<any>()
    const ContextProps = {
        checkItemData,
        setCheckItemData,
    }
    useEffect(() => {
        console.log('checkItemData', checkItemData)
            setListActiveIndex(null)
            let _list: any = deepCopy(store.ImgNotesTag)
            _list.map((i: any) => {
                i.isSelect = (i.id === checkItemData) ? true : false
            })
            dispatch({
                type: 'SET_IMGNOTESTAG',
                data: _list
            });
    }, [checkItemData])
    useEffect(() => {
        setListActiveIndex(null)
        console.log('store.ImgNotesTag', store.ImgNotesTag)
        if (instance) {
            let option: any = [];
            let sx: any = {
                "": false,
                // "label": "rect",
                // "creating": false,
                // "dragging": false,

                "textFillStyle": "#fff",
                // labelUp:false,
                // "fillStyle": "rgba(130,22,220,.6)",
                labelFillStyle: "red",
                "type": 1,
                labelFont: "10px sans-serif"
                //strokeStyle: "#0f0"
            }
            store.ImgNotesTag.map(((item: any, index: any) => {
                option.push({
                    ...sx, "label": ` ${index + 1} `,
                    // "labelFillStyle": (item.isSelect) ? "transparent" : "transparent",
                    // "textFillStyle": (item.isSelect) ? "#f00" : "#fff",
                    active: item.isSelect, description: item.description, coor: [[item.x, item.y], [item.w, item.h]]
                })
            }))
            instance.setData(option);
            setTimeout(() => {
                props.onChange && props.onChange(instance.dataset)
            }, 500);

        }
        // 加载数据
    }, [store.ImgNotesTag, instance])
    useEffect(() => {
        console.log('props.imgId', props.imgId)
        if (props.imgId) {
            setInstance(new CanvasSelect(".container", getImgUrlById(props.imgId)));
        }
    }, [props.imgId])
    useEffect(() => {
        console.log('modelFullScreen', store.modelFullScreen)
        let canvas: any = document.getElementById('canvasId');
        // canvas.style.width = store.modelFullScreen ? "800px" : "500px";
    }, [store.modelFullScreen])

    useEffect(() => {
        console.log('instanceDataset', instanceDataset, store.ImgNotesTag)
        if (instanceDataset && instanceDataset.length > 0) {
            let _list: any = []
            store.ImgNotesTag.map((i: any) => {
                _list.push({ ...i, isCompile: false })
            })
            let last = instanceDataset[instanceDataset.length - 1]
            _list.push({
                id: store.ImgNotesTag.length + 1,
                "x": last.coor[0][0],
                "y": last.coor[0][1],
                "w": last.coor[1][0],
                "h": last.coor[1][1],
                isCompile: true,
                subject: '',
                "description": "",
                isSelect: false,
                isCheck: false,
                isHover: false,
                ownerId: store.userInfo?.id
            })
            dispatch({
                type: 'SET_IMGNOTESTAG',
                data: _list
            });
        }
    }, [instanceDataset,])
    useEffect(() => {
        console.log('store.watchIsMark', store.watchIsMark, instance)
        if (instance) {
            // 0 不创建(默认)，1创建矩形，2创建多边形，3点标注，4折线标注，5圆形标注
            instance.createType = store.watchIsMark ? 0 : 1


            instance.on("add", (info: any) => {
                console.log("add", info);
                setInstanceDataset(instance.dataset)
                // 可对选中对参数info进行修改
                // 修改标签：info.label="hello"
                // 单个形状修改填充颜色：info.fillStyle="#0f0"
                // 然后调用instance.update()更新视图
                // let _list: any = []
                // store.ImgNotesTag.map((i: any) => {
                //     _list.push({ ...i, isCompile: false })
                // })
                // _list.push({
                //     id: store.ImgNotesTag.length+info.index-1,
                //     "x": info.coor[0][0],
                //     "y": info.coor[0][1],
                //     "w": info.coor[1][0],
                //     "h": info.coor[1][1],
                //     isCompile: true,
                //     subject: '',
                //     "description": "",
                //     isSelect: false,
                //     isCheck: false,
                //     isHover: false,
                //     ownerId: store.userInfo?.id
                // })
                // dispatch({
                //     type: 'SET_IMGNOTESTAG',
                //     data: _list
                // });
            });

        }
    }, [store.watchIsMark])
    useEffect(() => {
        if (instance) {
            instance.on("updated", (info: any) => {
                // console.log('updated', info)
            });
            instance.on("select", (info: any) => {
                console.log("select", info, instance.dataset);
                setListActiveIndex(info.index)
                // let _list: any = deepCopy(store.ImgNotesTag)
                // _list.map((i: any, index: any) => {
                //     console.log(i)
                //     i.x = info.coor[0][0];
                //     i.y = info.coor[0][1];
                //     i.w = info.coor[1][0];
                //     i.h = info.coor[1][1];
                //     i.isSelect = (index === info.index) ? true : false
                //     i.isCheck = (index === info.index) ? true : false
                //     i.isHover = (index === info.index) ? true : false
                //     i.isCompile = false
                //     // i.isCompile = (index === info.index) ? true : false
                // })
                // console.log(_list)
                // dispatch({
                //     type: 'SET_IMGNOTESTAG',
                //     data: _list
                // });
                props.onChange && props.onChange(instance.dataset)
                // let _ImgNotesTag:any=deepCopy(store.ImgNotesTag)
                // _ImgNotesTag.map((i: any) => {
                //    if(info.index==i.id){
                //     i.x= info.coor[0][0]
                //     i.y= info.coor[0][1]
                //     i.w=info.coor[1][0]
                //     i.h=info.coor[1][1]
                //    }
                // })
                // dispatch({
                //     type: 'SET_IMGNOTESTAG',
                //     data: _ImgNotesTag
                // });
                // 可对选中对参数info进行修改
                // 修改标签：info.label="hello"
                // 单个形状修改填充颜色：info.fillStyle="#0f0"
                // 然后调用instance.update()更新视图
            });
        }
    }, [instance])
    // let mous: any = UseOnMouse()
    const onDownload = () => {
        const element: any = document.getElementById('imgOver')
        html2canvas(element, { useCORS: true }).then(canvas => {
            const { width, height } = element.getBoundingClientRect()
            canvas.width = width
            canvas.height = height
            setImage(canvas.toDataURL('image/png'))
        })
    }
    //获取像素密度
    const getPixelRatio = (context: any) => {
        let backingStore: any = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
    }
    const toImage = () => {
        // window.scrollTo(0, 0);
        let shareContent: any = document.getElementById("imgOver"); // 需要绘制的部分的 (原生）dom 对象 ，注意容器的宽度不要使用百分比，使用固定宽度，避免缩放问题
        let width: any = shareContent.offsetWidth; // 获取(原生）dom 宽度
        let height: any = shareContent.offsetHeight; // 获取(原生）dom 高
        let offsetTop: any = shareContent.offsetTop; //元素距离顶部的偏移量
        let canvas: any = document.createElement("canvas"); //创建canvas 对象
        let context: any = canvas.getContext("2d");
        let scaleBy: any = getPixelRatio(context); //获取像素密度的方法 (也可以采用自定义缩放比例)
        canvas.width = width * scaleBy; //这里 由于绘制的dom 为固定宽度，居中，所以没有偏移
        // canvas.height = height * scaleBy; // 注意高度问题，由于顶部有个距离所以要加上顶部的距离，解决图像高度偏移问题
        context.scale(scaleBy, scaleBy);
        console.log("width-", width, "height", height, "offsetTop", offsetTop, "scaleBy", scaleBy);
        let opts: any = {
            useCORS: true, // 支持跨域图片的截取，不然图片截取不出来
            allowTaint: true, //允许加载跨域的图片
            tainttest: true, //检测每张图片都已经加载完成
            // scale: scaleBy, // 添加的scale 参数
            canvas: canvas, //自定义 canvas
            logging: true, //日志开关，发布的时候记得改成false
            width: width, //dom 原始宽度
            height: height, //dom 原始高度
            scrollY: 0,
            scrollX: 0,
            x: shareContent.offsetLeft,
            y: shareContent.offsetTop,
            windowWidth: '375px',
            windowHeight: '350px'
        };
        console.log(opts)
        // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
        html2canvas(shareContent, opts).then((canvas) => {
            document.body.appendChild(canvas);
            //canvas转img
            let drawing: any = document.getElementsByTagName("canvas")[0];
            //确定浏览器支持<canvas>元素
            if (drawing.getContext) {
                console.log("浏览器支持截图组件");
                var context = drawing.getContext("2d");
                // context.scale(2, 2);
                //取得图像的数据 URI
                var imgURI = drawing.toDataURL("image/png");
                //显示图像
                setImage(imgURI)
                var image = document.createElement("img");
                console.log("图像imgURI");
                image.src = imgURI;
                image.id = "down";
                document.body.appendChild(image);
            } else {
            }
        });
    }
    const columns: ColumnsType<DataType> = [
        {
            title: '序号',
            key: 'id',
            dataIndex: 'id',
            render: (record: any) => (

                <span>{record}
                </span>
            ),
        },
        {
            title: '说明',
            key: 'description',
            dataIndex: 'description',
            render: (record: any) => (

                <span>{record}
                </span>
            ),
        },
    ];
    const tableHeml = (list: any) => {
        return (
            <Table
                rowKey='id'
                pagination={false}
                columns={columns}
                dataSource={list}
                scroll={{ y: '45vh' }}
            />
        )
    }
    const listHtml = () => {
        return (
            <myContext.Provider value={ContextProps}>
                <M2niCascadedList attributeType={'limitCols'} initList={store.ImgNotesTag} fileItemEdit={(
                    data: any,
                    index: number,
                    colIndex: number,
                    onClickEdit: any,
                    setMoveNode: any,
                    setMovePlace: any,
                    list: any,
                    setInitNode: any,
                    activeIndex: number,
                    onGetList: any) => (<><FileItemEdit
                        attributeType={'limitCols'}
                        data={data}
                        //图片标注-删除某行标注说明时，其下各行的序号变化
                        html={<div className={style.colDivNum}>{index + 1}</div>}
                        index={index}
                        colIndex={colIndex}
                        onClickEdit={onClickEdit}
                        onGetList={onGetList}
                        activeIndex={listActiveIndex}
                        disable={(props.disable ? true : false)}
                        // setInitNode={setInitNode}
                        // setMoveNode={setMoveNode}
                        // setMovePlace={setMovePlace}
                        editItem={(e) => {
                            console.log(e)
                            let _dataList: any = store.ImgNotesTag
                            _dataList[index].subject = e
                            _dataList[index].description = e
                            data.subject = e
                            data.description = e
                            console.log(_dataList)
                            // setDataList(_dataList)
                            console.log(data)
                            //#fixd 新建图片标注时，新增2个标注并保存，鼠标覆盖第一行的标注时，第二行的标注切换为编辑模式
                            _dataList.map((i: any) => {
                                i.isCompile = false
                            })
                            dispatch({
                                type: 'SET_IMGNOTESTAG',
                                data: _dataList
                            });
                            // props.onChange && props.onChange(_dataList)
                        }}
                        onDel={(e) => {
                            let _dataList: any = deepCopy(store.ImgNotesTag)
                            _dataList.map((i: any) => {
                                i.isCompile = false
                            })
                            dispatch({
                                type: 'SET_IMGNOTESTAG_INDEX',
                                data: _dataList[index]
                            });
                            // _dataList.splice(index, 1);
                            console.log('SET_IMGNOTESTAG_INDEX', index)
                            dispatch({
                                type: 'SET_IMGNOTESTAG',
                                data: _dataList.filter((i: any, idx: any) => idx != index)
                            });
                        }}
                        list={list}
                    /></>)}></M2niCascadedList>
            </myContext.Provider>
        )
    }
    return (
        <div className=' pos-r ImageOverlays' style={{ height: '570px', width: store.modelFullScreen ? '100%' : '750px' }}>
            <div className={`${style.box}`} data-flex='main:left cross:top'>

                <div id='imgOver' data-flex='main:center cross:center' ref={imgOverAll} className={style.imgOver} style={{ flex: 1, }}>
                    <canvas id='canvasId' className="container" style={{
                        height: '570px',
                    }} ></canvas>
                    {/* <img alt="" onClick={() => {
                    }} src={(props.imgId) ? getImgUrlById(props.imgId) : user_default} onError={(e: any) => { e.target.onerror = null; e.target.src = user_default }} /> */}
                    {/* {props.disable && <div className='pos-r' style={{ width: '100%', height: '100%' }}>  < div className={`previewImg`}>
                        <Image
                            src={getImgUrlById(props.imgId)}
                            fallback={props.imgId}
                        />
                    </div></div>} */}
                </div>
                <div className={style.listBox}>
                    <div className={style.listBoxTit} data-flex="main:left cross:center">
                        <div className="ml-10" style={{ flex: '0 0 50px' }}>序号</div>
                        <div>说明</div>
                    </div>
                    <div style={{ marginTop: ' -20px' }}>
                        {listHtml()}
                    </div>
                </div>

                {!props.disable && <div className={style.btn} >
                    <div data-flex='main:left cross:center'>
                        <div className='mr-10 cursor' style={{ color: store.watchIsMark ? "#5F6264" : "#567AEF" }} onClick={() => {

                            if (store.watchIsMark) {
                                //显示现有标注
                                instance.setFocusMode(false);
                            }
                            dispatch({
                                type: 'SET_WATCHISMARK',
                                data: !store.watchIsMark
                            });
                        }}>
                            <TagOutlined />添加标注</div>
                        <div className='mr-10 cursor' style={{ color: isShowMark ? "#567AEF" : "#5F6264" }} onClick={() => {
                            setIsShowMark(!isShowMark)
                            //控制是否显示现有标注
                            instance.setFocusMode(!instance.focusMode);
                            // store.ImgNotesTag.map((i: any) => {
                            //     let bottom: any = document.querySelector(`#tagging${i.id}`);
                            //     console.log(bottom)
                            //     if (isShowMark) {
                            //         bottom.classList.add('hide');
                            //     } else {
                            //         bottom.classList.remove('hide');
                            //     }
                            //     bottom.style.opacity = isShowMark ? "0" : "1"
                            // })

                        }}>{isShowMark ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                            显示现有标注</div></div>
                    {/* <div onClick={() => { toImage() }}>点击生成toImage</div> */}
                    {/* <div onClick={() => { onDownload() }}>点击生成onDownload</div> */}
                    <p>
                        {/* x:<InputNumber min={1} max={10} defaultValue={mous.x} onChange={(e) => { }} />
                        y:<InputNumber min={1} max={10} defaultValue={mous.y} onChange={(e) => { }} />
                        w:<InputNumber min={1} max={10} defaultValue={mous.w} onChange={(e) => { }} />
                        h:<InputNumber min={1} max={10} defaultValue={mous.h} onChange={(e) => { }} /> */}
                        {/* {mous.x}px,y轴:{mous.y}px,宽度:{mous.w},高度:{mous.h} */}
                    </p>
                </div>}
            </div >
        </div >
    )
}

export default ImageOverlays
